import request from "../utils/fetch";

// 预警详情接口
export function earlyDetail(data) {
  return request({
    url: "/public/enterprise/warn/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 报警信息编辑
export function infoEdit(data) {
  return request({
    url: "/public/enterprise/warn/setting/edit",
    method: "PUT",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 套餐列表
export function setList(data) {
  return request({
    url: "/public/enterprise/warn/package/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 开关
export function open(data) {
  return request({
    url: "/public/enterprise/warn/open/change",
    method: "PUT",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 套餐订单创建并支付
export function setPay(data) {
  return request({
    url: "/public/enterprise/warn/order/create",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 订单查询订单生成时间
export function orderNoTime(data) {
  return request({
    url: "/public/enterprise/warn/order/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 关闭预警设备列表
export function closeList(data) {
  return request({
    url: "/public/enterprise/warn/black/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 关闭预警设备列表-添加
export function closeAdd(data) {
  return request({
    url: "/public/enterprise/warn/black/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 关闭预警设备列表-恢复
export function closeRecover(data) {
  return request({
    url: "/public/enterprise/warn/black/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 设备编号下拉
export function numPull(data) {
  return request({
    url: "/equipment/enterprise/pullList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 充值列表
export function topList(data) {
  return request({
    url: "/public/enterprise/warn/order/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 短信列表
export function msgList(data) {
  return request({
    url: "/public/enterprise/warn/msg/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 语音列表
export function callList(data) {
  return request({
    url: "/public/enterprise/warn/call/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 短信列表统计
export function msgStat(data) {
  return request({
    url: "/public/enterprise/warn/msg/statistics",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 语音列表统计
export function callStat(data) {
  return request({
    url: "/public/enterprise/warn/call/statistics",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
